<script setup>
import { Modal } from 'bootstrap';
import { onMounted, ref } from "vue";
import { QrcodeStream } from "vue-qrcode-reader"; 

let myModal;
const cameraOpen = ref(false);
const scannedCode = ref("");

onMounted(() => {
  myModal = new Modal(document.getElementById('scannerModal'));

  // Ensure the camera closes when the modal is hidden
  document.getElementById('scannerModal').addEventListener('hidden.bs.modal', () => {
    closeCamera();
  });
});

const openScanner = () => {
  myModal.show();
  cameraOpen.value = true;
};

const onDecode = (result) => {
  console.log("QR Code Scanned:", result); // Debug log
  if (result) {
    scannedCode.value = result;
    closeCamera(); // Close after successful scan (optional)
    myModal.hide(); // Hide modal after scanning
  }
};

const onInit = async (promise) => {
  try {
    await promise;
    console.log("Scanner initialized successfully.");
  } catch (error) {
    alert("Error initializing the camera. Please check permissions.");
    cameraOpen.value = false;
  }
};

const onError = (err) => {
  console.error("Scanner Error:", err);
};

const closeCamera = () => {
  console.log("Camera Closed");
  cameraOpen.value = false;
};
</script>

<template>
  <div class="fixed-plugin">
    <a class="px-3 py-2 fixed-plugin-button text-dark position-fixed" @click="openScanner">
      <i class="py-2 fa fa-camera"></i>
    </a>
  </div>

  <!-- Modal -->
  <div class="modal fade" id="scannerModal" tabindex="-1" aria-labelledby="scannerLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="scannerLabel">Scanner</h5>
          <button type="button" class="btn" data-bs-dismiss="modal" aria-label="Close" @click="closeCamera">X</button>
        </div>
        <div class="modal-body">
          <div class="row">
            <qrcode-stream
              v-if="cameraOpen"
              @decode="onDecode"
              @init="onInit"
              @error="onError"
              style="width: 100%; height: 400px;" 
            ></qrcode-stream>
          </div>
          <hr />
          <div class="row">
            <p>Scanned Code: {{ scannedCode }}</p>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="closeCamera">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>
